/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceFull,
  ItemInstanceFullOptional,
  ItemInstanceFullMetaI,
  ItemInstanceFullTrackedI,
} from "./item-instance-full";
import {
  ItemInstanceFullTracked,
  ItemInstanceFullMeta,
} from "./item-instance-full";

/**
 *
 * @export
 * @interface CatalogItemInstanceDTO
 */
export interface CatalogItemInstanceDTOOptional extends ItemInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  ignoreStock?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMin?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMax?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceCents?: number;
}

export interface CatalogItemInstanceDTO
  extends CatalogItemInstanceDTOOptional, ItemInstanceFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  ignoreStock?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  minQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  maxQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMin?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMax?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceCents?: number;
}

export interface CatalogItemInstanceDTOTrackedI extends ItemInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  ignoreStock?: boolean;
  ignoreStockIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  minQuantity?: number;
  minQuantityIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  maxQuantity?: number;
  maxQuantityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceDTO
   */
  allowPriceOverride?: boolean;
  allowPriceOverrideIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMin?: number;
  priceOverrideMinIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceOverrideMax?: number;
  priceOverrideMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceDTO
   */
  priceCents?: number;
  priceCentsIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemInstanceDTO",
  function (model: CatalogItemInstanceDTO) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type CatalogItemInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  ignoreStock: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  minQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  maxQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  allowPriceOverride: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  priceOverrideMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  priceOverrideMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  priceCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CatalogItemInstanceDTOMeta: CatalogItemInstanceDTOMetaI =
  {} as CatalogItemInstanceDTOMetaI;
CatalogItemInstanceDTOMeta = typeMeta("CatalogItemInstanceDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  ignoreStock: propertyMeta(
    "ignoreStock",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  minQuantity: propertyMeta(
    "minQuantity",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  maxQuantity: propertyMeta(
    "maxQuantity",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  allowPriceOverride: propertyMeta(
    "allowPriceOverride",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  priceOverrideMin: propertyMeta(
    "priceOverrideMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  priceOverrideMax: propertyMeta(
    "priceOverrideMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  priceCents: propertyMeta(
    "priceCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = CatalogItemInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemInstanceFullMeta]);
  metaI.isDeleted.inheritedFrom = ItemInstanceFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ItemInstanceFullMeta.isNew;
  metaI.assignId.inheritedFrom = ItemInstanceFullMeta.assignId;
  metaI.tempID.inheritedFrom = ItemInstanceFullMeta.tempID;
  metaI.startActive.inheritedFrom = ItemInstanceFullMeta.startActive;
  metaI.endActive.inheritedFrom = ItemInstanceFullMeta.endActive;
  metaI.ignoreStock.inheritedFrom = ItemInstanceFullMeta.ignoreStock;
  metaI.minQuantity.inheritedFrom = ItemInstanceFullMeta.minQuantity;
  metaI.maxQuantity.inheritedFrom = ItemInstanceFullMeta.maxQuantity;
  metaI.allowPriceOverride.inheritedFrom =
    ItemInstanceFullMeta.allowPriceOverride;
  metaI.priceOverrideMin.inheritedFrom = ItemInstanceFullMeta.priceOverrideMin;
  metaI.priceOverrideMax.inheritedFrom = ItemInstanceFullMeta.priceOverrideMax;
  metaI.priceCents.inheritedFrom = ItemInstanceFullMeta.priceCents;
});

export class CatalogItemInstanceDTOTracked
  extends ItemInstanceFullTracked
  implements CatalogItemInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  ignoreStock__I?: boolean = undefined;
  ignoreStockIsSet: boolean = false;
  set ignoreStock(v: undefined | boolean) {
    if (v !== undefined) {
      this.ignoreStock__I = v;
      this.ignoreStockIsSet = true;
    } else {
      this.ignoreStock__I = v || undefined;
      this.ignoreStockIsSet = false;
    }
    this.changeTracker = true;
  }
  get ignoreStock() {
    return this.ignoreStock__I;
  }
  minQuantity__I?: number = undefined;
  minQuantityIsSet: boolean = false;
  set minQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.minQuantity__I = v;
      this.minQuantityIsSet = true;
    } else {
      this.minQuantity__I = v || undefined;
      this.minQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get minQuantity() {
    return this.minQuantity__I;
  }
  maxQuantity__I?: number = undefined;
  maxQuantityIsSet: boolean = false;
  set maxQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.maxQuantity__I = v;
      this.maxQuantityIsSet = true;
    } else {
      this.maxQuantity__I = v || undefined;
      this.maxQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get maxQuantity() {
    return this.maxQuantity__I;
  }
  allowPriceOverride__I?: boolean = undefined;
  allowPriceOverrideIsSet: boolean = false;
  set allowPriceOverride(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowPriceOverride__I = v;
      this.allowPriceOverrideIsSet = true;
    } else {
      this.allowPriceOverride__I = v || undefined;
      this.allowPriceOverrideIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowPriceOverride() {
    return this.allowPriceOverride__I;
  }
  priceOverrideMin__I?: number = undefined;
  priceOverrideMinIsSet: boolean = false;
  set priceOverrideMin(v: undefined | number) {
    if (v !== undefined) {
      this.priceOverrideMin__I = v;
      this.priceOverrideMinIsSet = true;
    } else {
      this.priceOverrideMin__I = v || undefined;
      this.priceOverrideMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceOverrideMin() {
    return this.priceOverrideMin__I;
  }
  priceOverrideMax__I?: number = undefined;
  priceOverrideMaxIsSet: boolean = false;
  set priceOverrideMax(v: undefined | number) {
    if (v !== undefined) {
      this.priceOverrideMax__I = v;
      this.priceOverrideMaxIsSet = true;
    } else {
      this.priceOverrideMax__I = v || undefined;
      this.priceOverrideMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceOverrideMax() {
    return this.priceOverrideMax__I;
  }
  priceCents__I?: number = undefined;
  priceCentsIsSet: boolean = false;
  set priceCents(v: undefined | number) {
    if (v !== undefined) {
      this.priceCents__I = v;
      this.priceCentsIsSet = true;
    } else {
      this.priceCents__I = v || undefined;
      this.priceCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceCents() {
    return this.priceCents__I;
  }
  constructor(
    config?: CatalogItemInstanceDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogItemInstanceDTOOptional,
    options?: AssignOptions,
  ): CatalogItemInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.ignoreStock &&
      this.ignoreStockApplyFilter(optionsRequired.filter)
    ) {
      this.ignoreStock = config.ignoreStock;
      if (optionsRequired.unassign) this.ignoreStockIsSet = false;
      else this.ignoreStockIsSet = true;
    }
    if (
      config.minQuantity &&
      this.minQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.minQuantity = config.minQuantity;
      if (optionsRequired.unassign) this.minQuantityIsSet = false;
      else this.minQuantityIsSet = true;
    }
    if (
      config.maxQuantity &&
      this.maxQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.maxQuantity = config.maxQuantity;
      if (optionsRequired.unassign) this.maxQuantityIsSet = false;
      else this.maxQuantityIsSet = true;
    }
    if (
      config.allowPriceOverride &&
      this.allowPriceOverrideApplyFilter(optionsRequired.filter)
    ) {
      this.allowPriceOverride = config.allowPriceOverride;
      if (optionsRequired.unassign) this.allowPriceOverrideIsSet = false;
      else this.allowPriceOverrideIsSet = true;
    }
    if (
      config.priceOverrideMin &&
      this.priceOverrideMinApplyFilter(optionsRequired.filter)
    ) {
      this.priceOverrideMin = config.priceOverrideMin;
      if (optionsRequired.unassign) this.priceOverrideMinIsSet = false;
      else this.priceOverrideMinIsSet = true;
    }
    if (
      config.priceOverrideMax &&
      this.priceOverrideMaxApplyFilter(optionsRequired.filter)
    ) {
      this.priceOverrideMax = config.priceOverrideMax;
      if (optionsRequired.unassign) this.priceOverrideMaxIsSet = false;
      else this.priceOverrideMaxIsSet = true;
    }
    if (
      config.priceCents &&
      this.priceCentsApplyFilter(optionsRequired.filter)
    ) {
      this.priceCents = config.priceCents;
      if (optionsRequired.unassign) this.priceCentsIsSet = false;
      else this.priceCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemInstanceDTOTrackedI {
    const cloned = {} as CatalogItemInstanceDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.ignoreStockIsSetDeep() &&
      this.ignoreStockApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ignoreStockIsSet = true;
      cloned.ignoreStock = this.ignoreStock;
    } else {
      //cloned.ignoreStockIsSet = false
    }
    if (
      this.minQuantityIsSetDeep() &&
      this.minQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.minQuantityIsSet = true;
      cloned.minQuantity = this.minQuantity;
    } else {
      //cloned.minQuantityIsSet = false
    }
    if (
      this.maxQuantityIsSetDeep() &&
      this.maxQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.maxQuantityIsSet = true;
      cloned.maxQuantity = this.maxQuantity;
    } else {
      //cloned.maxQuantityIsSet = false
    }
    if (
      this.allowPriceOverrideIsSetDeep() &&
      this.allowPriceOverrideApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowPriceOverrideIsSet = true;
      cloned.allowPriceOverride = this.allowPriceOverride;
    } else {
      //cloned.allowPriceOverrideIsSet = false
    }
    if (
      this.priceOverrideMinIsSetDeep() &&
      this.priceOverrideMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceOverrideMinIsSet = true;
      cloned.priceOverrideMin = this.priceOverrideMin;
    } else {
      //cloned.priceOverrideMinIsSet = false
    }
    if (
      this.priceOverrideMaxIsSetDeep() &&
      this.priceOverrideMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceOverrideMaxIsSet = true;
      cloned.priceOverrideMax = this.priceOverrideMax;
    } else {
      //cloned.priceOverrideMaxIsSet = false
    }
    if (
      this.priceCentsIsSetDeep() &&
      this.priceCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceCentsIsSet = true;
      cloned.priceCents = this.priceCents;
    } else {
      //cloned.priceCentsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemInstanceDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.ignoreStockApplyFilter(filter)) this.ignoreStockIsSet = false;

    if (!this.minQuantityApplyFilter(filter)) this.minQuantityIsSet = false;

    if (!this.maxQuantityApplyFilter(filter)) this.maxQuantityIsSet = false;

    if (!this.allowPriceOverrideApplyFilter(filter))
      this.allowPriceOverrideIsSet = false;

    if (!this.priceOverrideMinApplyFilter(filter))
      this.priceOverrideMinIsSet = false;

    if (!this.priceOverrideMaxApplyFilter(filter))
      this.priceOverrideMaxIsSet = false;

    if (!this.priceCentsApplyFilter(filter)) this.priceCentsIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.isDeleted,
      CatalogItemInstanceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.isNew,
      CatalogItemInstanceDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.assignId,
      CatalogItemInstanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.tempID,
      CatalogItemInstanceDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.startActive,
      CatalogItemInstanceDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.endActive,
      CatalogItemInstanceDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  ignoreStockApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.ignoreStock,
      CatalogItemInstanceDTOMeta,
      this.ignoreStock,
      this,
    );
  }
  ignoreStockIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ignoreStockIsSet && this.ignoreStockApplyFilter(filter))
      return true;

    return false;
  }
  minQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.minQuantity,
      CatalogItemInstanceDTOMeta,
      this.minQuantity,
      this,
    );
  }
  minQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.minQuantityIsSet && this.minQuantityApplyFilter(filter))
      return true;

    return false;
  }
  maxQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.maxQuantity,
      CatalogItemInstanceDTOMeta,
      this.maxQuantity,
      this,
    );
  }
  maxQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.maxQuantityIsSet && this.maxQuantityApplyFilter(filter))
      return true;

    return false;
  }
  allowPriceOverrideApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.allowPriceOverride,
      CatalogItemInstanceDTOMeta,
      this.allowPriceOverride,
      this,
    );
  }
  allowPriceOverrideIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.allowPriceOverrideIsSet &&
      this.allowPriceOverrideApplyFilter(filter)
    )
      return true;

    return false;
  }
  priceOverrideMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.priceOverrideMin,
      CatalogItemInstanceDTOMeta,
      this.priceOverrideMin,
      this,
    );
  }
  priceOverrideMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceOverrideMinIsSet && this.priceOverrideMinApplyFilter(filter))
      return true;

    return false;
  }
  priceOverrideMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.priceOverrideMax,
      CatalogItemInstanceDTOMeta,
      this.priceOverrideMax,
      this,
    );
  }
  priceOverrideMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceOverrideMaxIsSet && this.priceOverrideMaxApplyFilter(filter))
      return true;

    return false;
  }
  priceCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceDTOMeta.priceCents,
      CatalogItemInstanceDTOMeta,
      this.priceCents,
      this,
    );
  }
  priceCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceCentsIsSet && this.priceCentsApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.ignoreStockIsSetDeep(filter)) return true;
    if (this.minQuantityIsSetDeep(filter)) return true;
    if (this.maxQuantityIsSetDeep(filter)) return true;
    if (this.allowPriceOverrideIsSetDeep(filter)) return true;
    if (this.priceOverrideMinIsSetDeep(filter)) return true;
    if (this.priceOverrideMaxIsSetDeep(filter)) return true;
    if (this.priceCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
